/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  var drawers = document.getElementsByClassName('custom-drawer-pdp');
  var drawers_close = document.getElementsByClassName('drawer__close-custom');
  var drawer_elems = document.getElementsByClassName('drawer--custom');

  var openCustomDrawer = function() {
    var attribute = this.getAttribute("data-drawer-toggle");
    document.querySelector('.drawer[data-drawer="'+attribute+'"]').classList.add('is-open');

    document.querySelector('.product__content').classList.add('drawer-open');
  };

  var closeCustomDrawer = function() {
    var attribute = this.getAttribute("data-drawer-toggle");
    document.querySelector('.drawer[data-drawer="'+attribute+'"]').classList.add('is-closing');
    
    setTimeout(() => {
      document.querySelector('.drawer[data-drawer="'+attribute+'"]').classList.remove('is-open');
      document.querySelector('.drawer[data-drawer="'+attribute+'"]').classList.remove('is-closing');
          
      document.querySelector('.product__content').classList.remove('drawer-open');
    }, 200);
    
  };

  for (var i = 0; i < drawers.length; i++) {
    drawers[i].addEventListener('click', openCustomDrawer, false);
  }
  
  for (var i = 0; i < drawers_close.length; i++) {
    drawers_close[i].addEventListener('click', closeCustomDrawer, false);
  }

  document.addEventListener('keyup', (e) => {
    if (e.code === 'Escape') {
      for (var i = 0; i < drawer_elems.length; i++) {
        if (drawer_elems[i].classList.contains('is-open')) {
          drawer_elems[i].classList.add('is-closing');
          setTimeout(() => {
            drawer_elems[i].classList.remove('is-open');
            drawer_elems[i].classList.remove('is-closing');
            document.querySelector('.product__content').classList.remove('drawer-open');
          }, 200);
          return false;
        }
      }
    }
  });

  document.body.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-drawer-underlay')) {
      for (var i = 0; i < drawer_elems.length; i++) {
        if (drawer_elems[i].classList.contains('is-open')) {
          drawer_elems[i].classList.add('is-closing');
          setTimeout(() => {
            drawer_elems[i].classList.remove('is-open');
            drawer_elems[i].classList.remove('is-closing');
            document.querySelector('.product__content').classList.remove('drawer-open');
          }, 200);
          return false;
        }
      }
    }
  });



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
